import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';
import { reportError } from './error-reporter';
import { toastError } from './notify';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => reportError('query', error),
    }),
    mutationCache: new MutationCache({
      onError: (error, _vars, _ctx, mutation) => {
        reportError('mutation', error);
        // A mutation with its own onError handles its message itself.
        if (!mutation.options.onError) toastError(error);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        // 4xx answers will not change on retry; network and 5xx might.
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
        refetchOnWindowFocus: true,
      },
    },
  });
}
